import { Controller } from 'react-hook-form';
import { FormFeedback } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { DatePicker } from 'components/date-picker';
import { s } from 'utilities/strings';

import { useGiftAmountConfiguration } from './hooks';

const StartDate = () => {
  const { control, errors } = useGiftAmountConfiguration();

  return (
    <Controller
      control={control}
      name="giftDateStart"
      render={({ field: { onChange, value } }) => (
        <>
          <DatePicker
            className={classNames({
              'is-invalid': get(errors, 'giftDateStart.type') === 'custom',
            })}
            onChange={(controlValue) => onChange(controlValue)}
            onClear={() => onChange(null)}
            placeholderText={s(['Site.Start', 'Site.Date'])}
            selected={value}
          />
          <FormFeedback type="invalid">{get(errors, 'giftDateStart.message')}</FormFeedback>
        </>
      )}
    />
  );
};

export default StartDate;
